import fetchJSON from '@gaia/utils/fetchJSON';
import {registerSavedFolder} from '@gaia/utils/gaia/saveFolder';

import {createFolder} from './create';

export default function createImportFolder(
    action: CreateImportFolderAction,
    setFolders: React.Dispatch<React.SetStateAction<{[localId: string]: Folder}>>
) {
    makeImportFolder(action)
        .then((folder) => {
            const newFolder = createFolder(folder);
            // Register it because we circumvented the save hook
            registerSavedFolder(newFolder);

            setFolders((latestFolders) => ({
                ...latestFolders,
                [newFolder.localId]: newFolder,
            }));

            if (action.callback) action.callback(newFolder);
        })
        .catch(console.warn);

    return [];
}

async function doesFolderExist(folderName: string) {
    const response = await fetchJSON(`/api/objects/folder/?search=${folderName}`);
    // ?search does a wildcard search so we need to check for exact matches
    return response.map((folder: any) => folder.title).includes(folderName);
}

async function makeImportFolder({name, bounds}: CreateImportFolderAction): Promise<Folder> {
    let folderName = name.replace(/[.|\s|\W]/g, '_');
    // Check if a folder with this name already exists
    let folderExists = await doesFolderExist(folderName);

    // If this name is already taken append a number until it isn't
    let version = 0;
    while (folderExists) {
        version++;
        folderExists = await doesFolderExist(`${folderName}_${version}`);
        if (!folderExists) {
            folderName = `${folderName}_${version}`;
        }
    }

    const folderResponse = await fetchJSON('/api/objects/folder/', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({title: folderName, imported: true}),
    });

    return {
        ...folderResponse.properties,
        title: folderResponse.properties.name,
        ...(bounds && {bounds}),
    };
}
